export const safeRound = (value: number, decimals: number) => {
    // Adding 1e-10 to mitigate floating-point precision errors (e.g. 48.55 stored as 48.54999999999999).
    // This ensures the number is rounded correctly when close to a boundary (e.g., 48.55 -> 48.6).
    return (value + 1e-10).toFixed(decimals)
}
